// Twilio error codes that matter for deliverability; anything else shows its raw code.
const DELIVERY_FAILURE_LABELS: Record<string, string> = {
  '30007': 'carrier filtered',
  '30003': 'number unreachable',
  '30005': 'number unreachable',
  '30006': 'number unreachable',
  '21211': 'number unreachable',
  '21610': 'recipient opted out',
};

interface DeliveredMessage {
  incoming: boolean;
  delivery_status?: string | null;
  error_code?: string | null;
}

/** "Not delivered · carrier filtered (30007)" for an outbound text Twilio could not deliver, else undefined. */
export const deliveryCaption = (msg: DeliveredMessage): string | undefined => {
  if (
    msg.incoming ||
    !['undelivered', 'failed'].includes(msg.delivery_status ?? '')
  ) {
    return undefined;
  }
  const code = msg.error_code ?? 'unknown';
  return `Not delivered · ${DELIVERY_FAILURE_LABELS[code] ?? 'error'} (${code})`;
};
